import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { MeetingPointsMapComponent } from './meeting-points-map/meeting-points-map.component';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';
import { NewMeetingPointModalComponent } from './new-meeting-point-modal/new-meeting-point-modal.component';
import { MeetingPointsTableComponent } from './meeting-points-table/meeting-points-table.component';
import { LocationModel} from "../../../models/resources/location.model";
import {LocationService} from "../../../services/resources/location.service";


@Component({
  selector: 'app-meeting-points',
  imports: [
    MdbButtonComponent,
    MeetingPointsMapComponent,
    MeetingPointsTableComponent
  ],
  templateUrl: './meeting-points.component.html',
  styleUrl: './meeting-points.component.scss',
})
export class MeetingPointsComponent implements OnInit {
  mapsReady = true;
  @Input() latitude = 48.2082;
  @Input() longitude= 16.3738;
  @Input() zoom = 4;

  mapCenter = computed(() => ({ lat: this.latitude, lng: this.longitude }));

  meetingPoint = signal<LocationModel[]>([]);

  private locationService = inject(LocationService);

  constructor(
    private modalService: MdbModalService,
    private notificationService: CustomNotificationService,
  ) {}

  location = {
    latitude: 48.2082,
    longitude: 16.3738
  };

  ngOnInit(): void {
    this.loadLocations();
    this.locationService.getAllInstant('address')
      .subscribe({
        next: (points) => {
          let meetingPoints = points.filter((points) => points.type === 'meeting_point'
          );
          this.meetingPoint.set(meetingPoints);
        },
    });
  }

  loadLocations(params: any = {}): void {

    this.locationService.getAll({
      ...params,
      urlParams: [
        ...(params.urlParams ?? []),
        {
          key: 'type',
          value: 'meeting_point'
        },
      ],
    });
  }

  openNewMeetingPointModal() {
    const modalRef = this.modalService.open(NewMeetingPointModalComponent, {
      modalClass: 'modal-xl',
      ignoreBackdropClick: true,
    });
    modalRef.onClose.subscribe((meetingPoint) => {
      if (!meetingPoint) return;

      this.notificationService.success('MEETING_POINTS.SUCCESSFULLY_CREATED');
      this.meetingPoint.update((list) => [...list, meetingPoint]);
    });
  }

  onMapClicked(coords: google.maps.LatLngLiteral) {
  }

  onMeetingPointDeleted(id: number){
    this.meetingPoint.update((list) => list.filter((point) => +point.id !== +id))
  }
}
